import type { Template } from "@/types";

export const PO_07_H4_V3: Template[] = [
    {
        id: "po-07-h4v3-01",
        name: "PO 01 - H4V3",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-07-h4_v3_01.png",
        size: [1298, 827],
        style: {},
        slots: [        
            { id: "1", x: 49, y: 233, width: 272, height: 177, rotation: 0, imageRotation: 0 },
            { id: "2", x: 49, y: 418, width: 272, height: 177, rotation: 0, imageRotation: 0 },
            { id: "3", x: 329, y: 233, width: 271, height: 177, rotation: 0, imageRotation: 0 },
            { id: "4", x: 329, y: 418, width: 271, height: 177, rotation: 0, imageRotation: 0 },
            { id: "5", x: 699, y: 162, width: 363, height: 503, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1070, y: 162, width: 177, height: 247, rotation: 0, imageRotation: 0 },
            { id: "7", x: 1070, y: 417, width: 177, height: 247, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-07-h4v3-02",
        name: "PO 02 - H4V3",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-07-h4_v3_02.png",
        size: [1298, 827],
        style: {},
        slots: [
            { id: "1", x: 62, y: 157, width: 526, height: 339, rotation: 0, imageRotation: 0 },        
            { id: "2", x: 62, y: 503, width: 259, height: 167, rotation: 0, imageRotation: 0 },
            { id: "3", x: 329, y: 503, width: 259, height: 167, rotation: 0, imageRotation: 0 },
            { id: "4", x: 700, y: 109, width: 548, height: 350, rotation: 0, imageRotation: 0 },
            { id: "5", x: 700, y: 466, width: 177, height: 251, rotation: 0, imageRotation: 0 },
            { id: "6", x: 885, y: 466, width: 177, height: 251, rotation: 0, imageRotation: 0 },
            { id: "7", x: 1070, y: 466, width: 177, height: 251, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-07-h4v3-03",
        name: "PO 03 - H4V3",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-07-h4_v3_03.png",
        size: [1298, 827],
        style: {},
        slots: [
            { id: "1", x: 50, y: 240, width: 548, height: 347, rotation: 0, imageRotation: 0 },
            { id: "2", x: 699, y: 240, width: 178, height: 111, rotation: 0, imageRotation: 0 },
            { id: "3", x: 699, y: 359, width: 178, height: 110, rotation: 0, imageRotation: 0 },
            { id: "4", x: 699, y: 477, width: 178, height: 110, rotation: 0, imageRotation: 0 },
            { id: "5", x: 885, y: 240, width: 230, height: 347, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1123, y: 240, width: 124, height: 170, rotation: 0, imageRotation: 0 },
            { id: "7", x: 1123, y: 418, width: 124, height: 169, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-07-h4v3-04",
        name: "PO 04 - H4V3",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-07-h4_v3_04.png",
        size: [1298, 827],
        style: {},
        slots: [
            { id: "1", x: 50, y: 157, width: 548, height: 395, rotation: 0, imageRotation: 0 },          
            { id: "2", x: 50, y: 559, width: 178, height: 111, rotation: 0, imageRotation: 0 },
            { id: "3", x: 236, y: 559, width: 177, height: 111, rotation: 0, imageRotation: 0 },
            { id: "4", x: 421, y: 559, width: 177, height: 111, rotation: 0, imageRotation: 0 },
            { id: "5", x: 677, y: 134, width: 391, height: 559, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1076, y: 134, width: 188, height: 276, rotation: 0, imageRotation: 0 },
            { id: "7", x: 1076, y: 418, width: 188, height: 275, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-07-h4v3-05",
        name: "PO 05 - H4V3",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-07-h4_v3_05.png",
        size: [1298, 827],
        style: {},
        slots: [
            { id: "1", x: 123, y: 220, width: 411, height: 253, rotation: 0, imageRotation: 0 },          
            { id: "2", x: 123, y: 480, width: 202, height: 128, rotation: 0, imageRotation: 0 },
            { id: "3", x: 333, y: 480, width: 201, height: 128, rotation: 0, imageRotation: 0 },
            { id: "4", x: 763, y: 220, width: 412, height: 191, rotation: 0, imageRotation: 0 },
            { id: "5", x: 763, y: 418, width: 133, height: 189, rotation: 0, imageRotation: 0 },
            { id: "6", x: 904, y: 418, width: 132, height: 189, rotation: 0, imageRotation: 0 },
            { id: "7", x: 1044, y: 418, width: 132, height: 189, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-07-h4v3-06",
        name: "PO 06 - H4V3",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-07-h4_v3_06.png",
        size: [1298, 827],
        style: {},
        slots: [
            { id: "1", x: 51, y: 220, width: 551, height: 270, rotation: 0, imageRotation: 0 },
            { id: "2", x: 767, y: 220, width: 272, height: 388, rotation: 0, imageRotation: 0 },
            { id: "3", x: 51, y: 498, width: 178, height: 110, rotation: 0, imageRotation: 0 },
            { id: "4", x: 237, y: 498, width: 178, height: 110, rotation: 0, imageRotation: 0 },
            { id: "5", x: 423, y: 498, width: 178, height: 110, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1047, y: 220, width: 133, height: 190, rotation: 0, imageRotation: 0 },
            { id: "7", x: 1047, y: 418, width: 133, height: 189, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-07-h4v3-07",
        name: "PO 07 - H4V3",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-07-h4_v3_07.png",
        size: [1298, 827],
        style: {},
        slots: [
            { id: "1", x: 29, y: 220, width: 591, height: 388, rotation: 0, imageRotation: 0 },          
            { id: "2", x: 676, y: 220, width: 195, height: 124, rotation: 0, imageRotation: 0 },
            { id: "3", x: 676, y: 352, width: 195, height: 124, rotation: 0, imageRotation: 0 },
            { id: "4", x: 676, y: 484, width: 195, height: 124, rotation: 0, imageRotation: 0 },
            { id: "5", x: 878, y: 220, width: 259, height: 388, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1144, y: 220, width: 122, height: 190, rotation: 0, imageRotation: 0 },
            { id: "7", x: 1144, y: 418, width: 122, height: 189, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-07-h4v3-08",
        name: "PO 08 - H4V3",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-07-h4_v3_08.png",
        size: [1298, 827],
        style: {},
        slots: [
            { id: "1", x: 0, y: 228, width: 247, height: 372, rotation: 0, imageRotation: 0 },
            { id: "2", x: 255, y: 228, width: 285, height: 182, rotation: 0, imageRotation: 0 },
            { id: "3", x: 255, y: 418, width: 285, height: 182, rotation: 0, imageRotation: 0 },
            { id: "4", x: 548, y: 228, width: 259, height: 372, rotation: 0, imageRotation: 0 },
            { id: "5", x: 815, y: 228, width: 285, height: 182, rotation: 0, imageRotation: 0 },
            { id: "6", x: 815, y: 418, width: 285, height: 182, rotation: 0, imageRotation: 0 },             
            { id: "7", x: 1108, y: 228, width: 248, height: 372, rotation: 0, imageRotation: 0 },
        ],
    },

    {
        id: "po-07-h4v3-09",
        name: "PO 09 - H4V3",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-07-h4_v3_09.png",
        size: [1298, 827],
        style: {},
        slots: [
            { id: "1", x: 0, y: 228, width: 285, height: 182, rotation: 0, imageRotation: 0 },
            { id: "2", x: 0, y: 418, width: 285, height: 182, rotation: 0, imageRotation: 0 },
            { id: "3", x: 293, y: 228, width: 251, height: 372, rotation: 0, imageRotation: 0 },
            { id: "4", x: 552, y: 228, width: 251, height: 372, rotation: 0, imageRotation: 0 },
            { id: "5", x: 811, y: 228, width: 250, height: 372, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1069, y: 228, width: 285, height: 182, rotation: 0, imageRotation: 0 },
            { id: "7", x: 1069, y: 418, width: 285, height: 182, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-07-h4v3-10",
        name: "PO 10 - H4V3",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-07-h4_v3_10.png",
        size: [1298, 827],
        style: {},
        slots: [
            { id: "1", x: 115, y: 126, width: 460, height: 284, rotation: 0, imageRotation: 0 },
            { id: "2", x: 115, y: 418, width: 460, height: 283, rotation: 0, imageRotation: 0 },
            { id: "3", x: 583, y: 126, width: 459, height: 284, rotation: 0, imageRotation: 0 },
            { id: "4", x: 583, y: 418, width: 459, height: 283, rotation: 0, imageRotation: 0 },
            { id: "5", x: 1050, y: 126, width: 133, height: 187, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1050, y: 321, width: 133, height: 186, rotation: 0, imageRotation: 0 },
            { id: "7", x: 1050, y: 515, width: 133, height: 186, rotation: 0, imageRotation: 0 }
        ],
    }
];